import { render } from "./bulk-suppliers-upload.vue?vue&type=template&id=1c751179&scoped=true"
import script from "./bulk-suppliers-upload.vue?vue&type=script&lang=js"
export * from "./bulk-suppliers-upload.vue?vue&type=script&lang=js"

import "./bulk-suppliers-upload.vue?vue&type=style&index=0&id=1c751179&scoped=true&lang=css"

import exportComponent from "/home/runner/work/inventflux-frontend/inventflux-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c751179"]])

export default __exports__